export default "__VITE_ASSET__RPwLZ8We__"